import React, { useState, useEffect } from 'react';
import { DateRangePicker } from 'react-bootstrap-daterangepicker';
import moment from 'moment';
import 'bootstrap-daterangepicker/daterangepicker.css';
// import axios from 'axios';
moment.locale('en');

const BotResponseTableUI = () => {
  const [selectedRangeTrans, setSelectedRangeTrans] = useState("");
  const [tableData, setTableData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [byNumData, setByNumData] = useState([]);

  const fetchData = async (fromDate, toDate) => {
    setLoading(true);
    try {
      const apiUrl = `https://oneml.spectra.co/getUserResponse?fromDate=${fromDate}&toDate=${toDate}`;

      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        // body: JSON.stringify(requestData),
      });
      const result = await response.json();
      // console.log("result", result.data.botResponse1);
      if (result?.data?.botResponse1) {
        
        const formattedData = result.data.botResponse1.map(item => {
          const dateObj = new Date(item.created_at);

          // Format date like "02 June 2025"
          const date = dateObj.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
          });

          // Format time like "07:26 PM"
          const time = dateObj.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });

          return {
            ...item,
            date,
            time,
          };
        });

        setTableData(formattedData);
        // setTableData(result.data.botResponse1);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);

    } finally {
      setLoading(false);
    }
  };

  const handleDateRangeChangeTrans = (event, picker) => {
    const start = moment(picker.startDate).format("MMM DD, YYYY");
    const end = moment(picker.endDate).format("MMM DD, YYYY");
    setSelectedRangeTrans(`${start} - ${end}`);

    const apiStart = moment(picker.startDate).format("YYYY-MM-DD");
    const apiEnd = moment(picker.endDate).format("YYYY-MM-DD");
    fetchData(apiStart, apiEnd);
  };

  // Fetch today's data on initial render
  useEffect(() => {
    const today = moment().format("YYYY-MM-DD");
    setSelectedRangeTrans(`${moment().format("MMM DD, YYYY")} - ${moment().format("MMM DD, YYYY")}`);
    fetchData(today, today);
  }, []);


  const handleInputValue = (e) => {
    setInputValue(e.target.value)
  }


  const handleSearch = async () => {
    try {
      setLoading(true);
      const apiUrl = "https://oneml.spectra.co/getUserResponseByNum";
      const requestData = {
        "mobileNum": inputValue
      }
      // Fetch data from the API
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const result = await response.json();

      // console.log("getUserResponseByNum", result?.data.response);

      if (result?.data.response) {

        const formatData = result?.data.response.map(item => {
          const dateObj = new Date(item.created_at);

          // Format date like "02 June 2025"
          const date = dateObj.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
          });

          // Format time like "07:26 PM"
          const time = dateObj.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });

          return {
            ...item,
            date,
            time,
          };
        });

        
        setByNumData(formatData)
        setFlag(true);
      } else {
        setByNumData([])
      }



    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div className="container-fluid py-4 px-3">
        <div className="row g-4 align-items-end mb-4">
          {/* Date Range Picker */}
          <div className="col-md-4">
            <label className="form-label fw-bold">Date Range</label>
            <DateRangePicker
              initialSettings={{
                ranges: {
                  '1 Month': [moment().subtract(1, 'months'), moment()],
                  '3 Months': [moment().subtract(3, 'months'), moment()],
                  '6 Months': [moment().subtract(6, 'months'), moment()],
                  '9 Months': [moment().subtract(9, 'months'), moment().subtract(1, 'days')],
                  '1 Year': [moment().subtract(1, 'years'), moment()],
                },
                maxDate: new Date(),
              }}
              onApply={handleDateRangeChangeTrans}
            >
              <div className="spectra-dropdown">
                <div className="select-custom dropdown-toggle rounded border p-2 bg-white shadow-sm cursor-pointer">
                  <div className="d-flex align-items-center gap-2">
                    <span>{selectedRangeTrans || "Select Date Range"}</span>
                  </div>
                </div>
              </div>
            </DateRangePicker>
          </div>

          {/* Search Input */}
          <div className="col-md-4">
            <label className="form-label fw-bold">Search</label>
            <input
              type="search"
              value={inputValue}
              onChange={handleInputValue}
              className="form-control shadow-sm"
              placeholder="Search by keyword..."
            />
          </div>

          {/* Search Button */}
          <div className="col-md-4">
            <button
              className="btn btn-dark w-100 shadow-sm"
              type="button"
              onClick={handleSearch}
            >
              Search
            </button>
          </div>
        </div>

        {/* Loader */}
        {loading ? (
          <div className="loader-wrapper d-flex justify-content-center py-5">
            <img src="https://media.tenor.com/IfbOs_yh89AAAAAM/loading-buffering.gif" alt="Loading..." className="loader-img" />
          </div>
        ) : (
          <div className="table-responsive-sm">
            <table className="table table-striped table-bordered align-middle">
              <thead className="table-dark">
                <tr>
                  <th>ID</th>
                  <th>Mobile Number</th>
                  <th>User Response</th>
                  <th>Created Date</th>
                  <th>Created Time</th>
                </tr>
              </thead>
              <tbody>
                {(flag ? byNumData : tableData).length > 0 ? (
                  (flag ? byNumData : tableData).map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.mobile}</td>
                      <td>{item.user_response}</td>
                      <td>{item.date}</td>
                      <td>{item.time}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">No data found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

    </>
  );
};

export default BotResponseTableUI;
